// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__zPqe2","logoimage":"Logo_logoimage__1jTDJ","countrySign":"Logo_countrySign__1Bcav"};